import { toast } from 'sonner'
import { v4 as uuidv4 } from 'uuid'

import { useAuthInfo } from '@sweetauth/core'

import { SweetspotError } from '@/helpers/error'

import { reportDatadogError } from '@/lib/datadog'

const STATUS_CODE_TO_MESSAGE = {
  403: 'You are not authorized to perform this action.',
  413: 'File size must be less than 50MB.',
  415: 'File type not supported.',
}

export const useHandleError = () => {
  const { user } = useAuthInfo()
  const handleError = (
    error: any | SweetspotError,
    noToast: boolean = false,
    message?: string,
  ) => {
    const errorId = uuidv4()
    if (typeof window !== 'undefined') {
      reportDatadogError(error, {
        url: window.location.href,
        userId: user?.userId,
        handler: 'useHandleError',
        errorId,
      })
    }

    const statusCode = error.cause?.status || error.status
    let msg: string
    if (message !== undefined) {
      msg = message
    } else if (
      statusCode &&
      typeof statusCode === 'number' &&
      statusCode in STATUS_CODE_TO_MESSAGE
    ) {
      msg =
        STATUS_CODE_TO_MESSAGE[
          statusCode as keyof typeof STATUS_CODE_TO_MESSAGE
        ]
    } else if (typeof error.cause?.detail === 'string' && error.cause.detail) {
      msg = error.cause.detail
    } else {
      msg = 'Something went wrong. Please try again later.'
    }
    if (!noToast) {
      toast.error(msg, { closeButton: true, duration: 8000 })
    }
    if (process.env.NODE_ENV !== 'production') {
      console.error(error)
    }
  }
  return { handleError }
}
